/*
 *  IRIS Interactive
 *
 *  NOTICE OF LICENSE
 *  This source file is no subject to a specific license
 *  but it belongs to the company IRIS Interactive.
 *  You can contact IRIS Interactive at the following
 *  address: contact@iris-interactive.fr
 *
 *  @author      Lucas Roche
 *  @date        25/06/2021 11:39
 *  @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */
// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
class FormEnum {
    static SUCCESS_EVENT = 'frmFormComplete'
    static ERROR_EVENT = 'frmFormErrors'
    static SUCCESS_MESSAGE = IRISCollectionTheme.translate.successForm
}

export const SUCCESS_EVENT = FormEnum.SUCCESS_EVENT
export const ERROR_EVENT = FormEnum.ERROR_EVENT
export const SUCCESS_MESSAGE = FormEnum.SUCCESS_MESSAGE
